import React from "react";
import "./ComboMessage.scss";

const ComboMessage = ({ comboMessage }) => {
  const { color, message, icon, title } = comboMessage;
  return (
    <div className="combo-message-wrapper" style={{ background: color }}>
      <div className="combo-message-content">
        <div className="combo-message-icon">
          <img src={icon} alt="combo-message-icon" />
        </div>

        <div>
          <div className="combo-message-title">{title}</div>
          <div className="combo-message-message">{message}</div>
        </div>
      </div>
    </div>
  );
};

export default ComboMessage;
